module.exports = __webpack_public_path__ + "static/media/H_on.892ff360.svg";